import { ICoffeeLeadIssueView } from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { CoffeeLeadIssueCategory } from '../../../../../extViewmodels';
import { linkifyText } from '../../../../../models/UxUtils';
import { Group } from '../../../../components/generics/Group';
import { SimpleCheckbox } from '../../../../components/generics/SimpleCheckbox';
import { LeadServedSource } from '../../../../viewModels/queue';
import { styleSheet } from '../styles';

const CategoryLabels: Record<CoffeeLeadIssueCategory, string> = {
	[CoffeeLeadIssueCategory.WrongLocationOrTimeZone]: 'Wrong Location/Timezone',
	[CoffeeLeadIssueCategory.Duplicate]: 'Duplicate',
	[CoffeeLeadIssueCategory.CurrentClientNeedsAttention]: 'Current Client Needs Attention',
	[CoffeeLeadIssueCategory.Other]: 'Other',
};

interface IProps {
	item: ICoffeeLeadIssueView;
	onMarkComplete?: (issueId: string) => void;
}

export const ListItem: React.FC<IProps> = ({ item, onMarkComplete }) => {
	const handleChangeComplete = () => onMarkComplete?.(item.id);

	const date = item.creationDate ? moment(item.creationDate).format('h:mma MMM D') : 'Unknown';
	const isComplete = !!item.completionDate;
	const reporterName = item.reporter ? `${item.reporter.firstName} ${item.reporter.lastName}` : 'Unknown';
	const leadUrl = item.companyId
		? `${window.location.origin}/#/queue?from=${LeadServedSource.SharedLink}&companyId=${item.companyId}`
		: null;

	return (
		<div className={css(styleSheet.listItemsContainer)}>
			<div className={css(styleSheet.card)}>
				<div className={css(styleSheet.cardTicketStrip)}>
					<span className={css(styleSheet.cardTicketLabel)}>
						{reporterName} &mdash; {date}
					</span>
					<div className={css(styleSheet.cardTicketRight)}>
						{isComplete && (
							<span className={css(styleSheet.completedInfo)}>
								{moment(item.completionDate).format('MM/DD/YYYY')}
								{item.completedBy && ` — ${item.completedBy.firstName} ${item.completedBy.lastName}`}
							</span>
						)}
						<SimpleCheckbox
							className={css(styleSheet.checkbox, isComplete ? styleSheet.checkboxComplete : null)}
							checked={isComplete}
							disabled={isComplete}
							id={`complete-issue-${item.id}`}
							label='Complete'
							onChange={!isComplete ? handleChangeComplete : undefined}
						/>
					</div>
				</div>
				<div className={css(styleSheet.cardBody)}>
					<Group vCentered>
						<div className={css(styleSheet.cardRegularText, styleSheet.itemCompany)}>
							<span className={css(styleSheet.cardRegularTextTitle)}>LEAD</span>
							<br />
							{leadUrl ? (
								<a className={css(styleSheet.leadLink)} href={leadUrl} target='_blank' rel='noreferrer'>
									{item.companyName || 'Unknown'}
								</a>
							) : (
								item.companyName || 'Unknown'
							)}
						</div>
						<div className={css(styleSheet.cardRegularText, styleSheet.itemCategory)}>
							<span className={css(styleSheet.cardRegularTextTitle)}>CATEGORY</span>
							<br />
							{CategoryLabels[item.category] || item.category}
						</div>
						<div className={css(styleSheet.cardRegularText, styleSheet.itemDescription)}>
							<span className={css(styleSheet.cardRegularTextTitle)}>DESCRIPTION</span>
							<div className={css(styleSheet.cardDescription)}>{linkifyText(item.description)}</div>
						</div>
					</Group>
				</div>
			</div>
		</div>
	);
};
